module.exports = __webpack_public_path__ + "img/user-profile-active.f2d88e0a.svg";